import { Entity } from "./entity"
import { ProductStatus, ProductType, ReservationStatus } from "./enum-type";

export interface Product extends Entity {
  laverieId: string
  storageDepotId: string
  model: string
  price: number
  aquaNb: number
  serialNb: string
  compteur: number
  bonEntreeNb: number
  bonEntreeDate: string
  destructionDate: Date
  localisation: string
  notificationEnabled: boolean
  productMake: string
  productType: ProductType
  productStatus: ProductStatus
  reservationStatus: ReservationStatus
}

export class ProductExport {
  prdts: Product[];
}

export function getProductExport(products: Product[]): ProductExport {
  const productsExport = new ProductExport();
  productsExport.prdts = products;
  return productsExport;
}